<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-4 pr-4 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-tour name="myTour" :steps="steps" :options="myOptions"></v-tour>
        <v-tour name="myTourPage" :steps="stepsPage" :options="myOptionsPage"></v-tour>
        <v-breadcrumbs class="pl-0 pb-10" :items="breadcrumbs" id="v-step-2" divider=">"></v-breadcrumbs>
        <v-row>
          <!-- Dialog export / import -->
          <!-- <v-col cols="12">
            <v-btn color="primary" depressed @click="dialogAdd = true">
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
          </v-col> -->
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข้อมูล</span>
                <v-spacer></v-spacer>
                  <v-checkbox
                    v-model="canvas"
                    label="เปิด / ปิด Canvas"
                  ></v-checkbox>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color1"
                        dense
                        icon="mdi-alpha-h-box"
                        type="success"
                        border="bottom"
                      >Headline</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color2"
                        dense
                        icon="mdi-alpha-i-box"
                        type="success"
                        border="bottom"
                      >Icon</v-alert>
                    </v-col>
                  </v-row>
                    <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color1"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color2"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color3"
                        dense
                        icon="mdi-alpha-s-box"
                        type="success"
                        border="bottom"
                      >Sub-headline</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color4"
                        dense
                        icon="mdi-format-header-2"
                        type="success"
                        border="bottom"
                      >Headline 2</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color3"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color4"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color5"
                        dense
                        icon="mdi-alpha-s-box-outline"
                        type="success"
                        border="bottom"
                      >Sub-headline 2</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color6"
                        dense
                        icon="mdi-alpha-i-box-outline"
                        type="success"
                        border="bottom"
                      >lcon 2</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color5"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color6"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formAdd.color7"
                        dense
                        icon="mdi-alpha-p-box"
                        type="success"
                        border="bottom"
                      >Picture</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formAdd.color7"></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="dark darken-1"
                  @click="dialogAdd = false,clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title id="v-step-1">
                <span class="headline">แก้ไขข้อมูล</span>
                <v-spacer></v-spacer>
                  <v-checkbox
                    v-model="canvas"
                    label="เปิด / ปิด Canvas"
                  ></v-checkbox>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color1"
                        dense
                        icon="mdi-alpha-h-box"
                        type="success"
                        border="bottom"
                      >Headline</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color2"
                        dense
                        icon="mdi-alpha-i-box"
                        type="success"
                        border="bottom"
                      >Icon</v-alert>
                    </v-col>
                  </v-row>
                    <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color1"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color2"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color3"
                        dense
                        icon="mdi-alpha-s-box"
                        type="success"
                        border="bottom"
                      >Sub-headline</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color4"
                        dense
                        icon="mdi-format-header-2"
                        type="success"
                        border="bottom"
                      >Headline 2</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color3"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color4"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color5"
                        dense
                        icon="mdi-alpha-s-box-outline"
                        type="success"
                        border="bottom"
                      >Sub-headline 2</v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color6"
                        dense
                        icon="mdi-alpha-i-box-outline"
                        type="success"
                        border="bottom"
                      >lcon 2</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color5"></v-color-picker>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color6"></v-color-picker>
                    </v-col>
                  </v-row>
                  <v-row style="height: 50px">
                    <v-col cols="6">
                      <v-alert
                        :color="formUpdate.color7"
                        dense
                        icon="mdi-alpha-p-box"
                        type="success"
                        border="bottom"
                      >Picture</v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="d-flex justify-center">
                        <v-color-picker :hide-canvas="!canvas" mode="hexa" hide-mode-switch v-model="formUpdate.color7"></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="success"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส สี*"
                        v-model="formUpdate.colorId"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
         <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  dense
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.color1`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color1"></span>
                  </template>
                  <template v-slot:[`item.color2`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color2"></span>
                  </template>
                  <template v-slot:[`item.color3`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color3"></span>
                  </template>
                  <template v-slot:[`item.color4`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color4"></span>
                  </template>
                  <template v-slot:[`item.color5`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color5"></span>
                  </template>
                  <template v-slot:[`item.color6`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color6"></span>
                  </template>
                  <template v-slot:[`item.color7`]="{ item }">
                      <span class="div_color" :style="'background-color:'+item.color7"></span>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="btn-color"
                      fab
                      dark
                      id="v-step-0"
                      x-small
                      @click.stop="(dialogEdit = true), getDataById(item)"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                     </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
        </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      myOptionsPage: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'ข้ามการแนะนำ',
          buttonPrevious: 'ย้อนกลับ',
          buttonNext: 'ต่อไป',
          buttonStop: 'จบการแนะนำ'
        }
      },
      stepsPage: [
        {
          target: '#v-step-0',
          header: {
            title: 'เริ่มต้นการแก้ไข Theme'
          },
          content: 'กดปุ่มแก้ไข <strong>Theme</strong>',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogAdd = false, this.dialogEdit = false)
          })
        },
        {
          target: '#v-step-1',
          content: 'เลือก Theme ต้องการ แล้วกด <strong>แก้ไข</strong>',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogEdit = true)
          })
        },
        {
          target: '#v-step-2',
          content: '<strong>จบการแนะนำ</strong><br>ขอบคุณครับ',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogEdit = false)
          })
        }
      ],
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'ข้ามการแนะนำ',
          buttonPrevious: 'ย้อนกลับ',
          buttonNext: 'ต่อไป',
          buttonStop: 'จบการแนะนำและนำไปการจัดการ Theme'
        }
      },
      steps: [
        {
          target: '#v-step-0',
          header: {
            title: 'เริ่มต้นการแก้ไข Theme'
          },
          content: 'กดปุ่มแก้ไข <strong>Theme</strong>',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogAdd = false, this.dialogEdit = false)
          })
        },
        {
          target: '#v-step-1',
          content: 'เลือก Theme ต้องการ แล้วกด <strong>แก้ไข</strong>',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogEdit = true)
          })
        },
        {
          target: '#v-step-2',
          params: {
            highlight: true
          },
          before: type => new Promise((resolve, reject) => {
            // Time-consuming UI/async operation here
            resolve(this.dialogEdit = false, this.$router.push('/Master/Level?tour=true'))
          })
        }
      ],
      PK: '',
      path: '/color/', // Path Model
      returnLink: '/Master/Color',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สี',
          disabled: false,
          href: '/Master/Color'
        }
      ],
      // End Menu Config
      dataReady: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        color1: '',
        color2: '',
        color3: '',
        color4: '',
        color5: '',
        color6: '',
        color7: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        colorId: '',
        color1: '',
        color2: '',
        color3: '',
        color4: '',
        color5: '',
        color6: '',
        color7: '',
        LAST_USER: '',
        shopId: ''
      },
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 50 || 'Name must be less than 50 characters'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ID', value: 'colorId' },
        { text: 'Headline', value: 'color1' },
        { text: 'Icon', value: 'color2' },
        { text: 'Sub-headline', value: 'color3' },
        { text: 'Headline 2', value: 'color4' },
        { text: 'Sub-headline 2', value: 'color5' },
        { text: 'Icon 2', value: 'color6' },
        { text: 'Picture Background', value: 'color7' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: []
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId, this.returnLink)
    // if (this.$route.query.tour) {
    //   if (this.$route.query.tour === 'true') {
    //     this.$tours['myTour'].start()
    //   } else {
    //     this.$tours['myTourPage'].start()
    //   }
    // }
  },
  methods: {
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?colorId=' + this.searchAll +
         '&color1=' + this.searchAll +
         '&color2=' + this.searchAll +
         '&color3=' + this.searchAll +
         '&color4=' + this.searchAll +
         '&color5=' + this.searchAll +
         '&color6=' + this.searchAll +
         '&color7=' + this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      this.getDataByIdGlobal(this.DNS_IP, this.path, 'colorId', item.colorId, this.returnLink)
      console.log('kkk', this.getDataByIdGlobal(this.DNS_IP, this.path, 'colorId', item.colorId, this.returnLink))
    },
    async addData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd
            //   {
            //     headers: {
            //       'Application-Key': this.$session.getAll().ApplicationKey
            //     }
            //   }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId, this.returnLink)
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.colorId
          delete this.formUpdate['colorId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId, this.returnLink)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.colorId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(this.DNS_IP, this.path, this.formUpdate.colorId, this.session.data.shopId, this.returnLink)
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }

      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    }
  }
}
</script>
<style scoped>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4);
}
.div_color {
  width:65px;
  height:65px;
  display:block;
  border-radius: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Color.vue